import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [VIEW_ESTIMATE, VIEW_ESTIMATE_SUCCESS, VIEW_ESTIMATE_FAILURE] =
  createRequestActionTypes('chance/VIEW_ESTIMATE');
export const viewEstimate = createAction(VIEW_ESTIMATE, (id) => id);
const viewEstimateSaga = createRequestSaga(VIEW_ESTIMATE, chanceApi.getActiveEstimate);



const UNLOAD_ESTIMATE = 'chance/UNLOAD_ESTIMATE';
export const unloadEstimate = createAction(UNLOAD_ESTIMATE);

const SET_ESTIMATE = 'chance/SET_ESTIMATE';
export const setEstimate = createAction(SET_ESTIMATE, (chance) => chance);


export function* chanceEstimateSaga() {
  yield takeLatest(VIEW_ESTIMATE, viewEstimateSaga);

}

const initialState = {
  estimate: null,
  error: null,
};

const chanceEstimate = handleActions(
  {
    [VIEW_ESTIMATE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      estimate: data.info,
    }),
    [VIEW_ESTIMATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),

    [UNLOAD_ESTIMATE]: () => initialState,
    [SET_ESTIMATE]: (state, { payload: estimate }) => ({
      ...state,
      estimate: estimate,
    }),

  },
  initialState,
);

export default chanceEstimate;
